import type { FunctionComponent } from 'react';

import { Spinner } from '@trello/nachos/spinner';
import { CardBackTestIds } from '@trello/test-ids';

import styles from './CardBackLoading.less';

export const CardBackLoading: FunctionComponent = () => (
  <div
    className={styles.cardDetailLoading}
    data-testid={CardBackTestIds.CardBackLoading}
  >
    <Spinner centered={true} />
  </div>
);
